"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyFilter = exports.filters = void 0;
const moment = require("moment");
const numeral = require("numeral");
const constants_1 = require("../constants");
const INVALID_NUMBER_RESPONSE = '--';
exports.filters = {
    number: (value) => {
        if (typeof value !== 'number')
            value = +value;
        if (isNaN(value))
            return INVALID_NUMBER_RESPONSE;
        const formattedValue = numeral(value).format('0,0.0');
        const splitValue = formattedValue.split('.');
        if (splitValue[1] === '0') {
            return splitValue[0];
        }
        else {
            return formattedValue;
        }
    },
    currency: (value) => {
        if (typeof value !== 'number')
            value = +value;
        if (isNaN(value))
            return INVALID_NUMBER_RESPONSE;
        return numeral(value).format('$0,0.00');
    },
    date: (val, args = {
        parseDateToUTC: false,
        format: 'DD/MM/YYYY',
    }) => {
        if (!val || val.length < 8)
            return '--';
        let date;
        if (args.parseDateToUTC)
            date = moment.utc(val.toLocaleUpperCase());
        else
            date = moment(val.toLocaleUpperCase());
        if (!date.isValid())
            return '--';
        return date.format(args.format);
    },
    time: (val, args = {
        parseDateToUTC: true,
    }) => {
        let date;
        if (args.parseDateToUTC)
            date = moment.utc(val);
        else
            date = moment(val);
        if (!date.isValid())
            return '--';
        return date.format('HH:mm');
    },
    timeFromNow: (val, args = {
        parseDateToUTC: false,
    }) => {
        const date = args.parseDateToUTC ? moment.utc(val) : moment(val);
        return !date.isValid() ? '--' : date.fromNow();
    },
    percent: function (val) {
        if (typeof val === 'string')
            val = +val;
        val *= 100;
        const formatNumber = this.number(val);
        if (formatNumber === INVALID_NUMBER_RESPONSE)
            return INVALID_NUMBER_RESPONSE;
        return `${formatNumber}%`;
    },
    textToUppercase: (val) => val.toUpperCase(),
    booleanToString: (val) => {
        if ((typeof val === 'string' && val === 'true') ||
            (typeof val === 'boolean' && val)) {
            return 'Sí';
        }
        else {
            return 'No';
        }
    },
    capitalize: (text) => {
        let space = '';
        return text
            ? text
                .trim()
                .split(' ')
                .map((word, index) => {
                space = index === 0 ? '' : ' ';
                return word.length
                    ? `${space}${word[0].toUpperCase()}${word.slice(1)}`
                    : '';
            })
                .join('')
            : '';
    },
    normalizeString: (val) => {
        if (!val || val === '')
            return '';
        return val.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
    normalizeStringForSearch: function (val) {
        return this.normalizeString(val).toLowerCase();
    },
    bytesToString: (bytes) => bytes < constants_1.kilobyte
        ? `${bytes} B`
        : bytes < constants_1.megabyte
            ? `${Math.round(bytes / constants_1.kilobyte)} KB`
            : `${Math.round(bytes / constants_1.megabyte)} MB`,
};
const applyFilter = (filterName, value, args) => {
    if (args && Object.keys(args).length)
        return exports.filters[filterName](value, args);
    else
        return exports.filters[filterName](value);
};
exports.applyFilter = applyFilter;
